import {
    IApiQueryFunction,
    IOrderable,
    IPaginateable,
    createApiQueryHook,
    mapOrder,
    mapPagination,
} from "../../utils/api";
import { OneOrManyFilter, RelationalFilter, mapRelationalFilter } from "../../utils/filters";
import { serialize } from "../../utils/url";
import { IUserList, IUserResource, UserRole, UserStatus } from "../types";

export interface IUserListQueryParameters
    extends IPaginateable, IOrderable<"updatedAt" | "createdAt" | "email" | "name" | "surname" | "roles" | "status"> {
    filters?: {
        emails?: OneOrManyFilter<string>;
        name?: string;
        surname?: string;
        status?: OneOrManyFilter<UserStatus>;
        role?: UserRole;
        hasWrittenFollowUpForLearner?: RelationalFilter<IUserResource>;
        fullname?: string;
        groups?: string[];
    };
}

export type IUserListQueryResult = IUserList;

const mapFilters = (filters: IUserListQueryParameters["filters"]) => {
    const { emails, name, surname, status, role, hasWrittenFollowUpForLearner, fullname, groups } = filters ?? {};

    return {
        email: emails,
        name,
        surname,
        status,
        roles: role,
        follow_ups_for_learner: mapRelationalFilter(hasWrittenFollowUpForLearner),
        fullname,
        groups,
    };
};

export const userListQuery: IApiQueryFunction<IUserListQueryParameters> = ({ filters, order, pagination }) => {
    return {
        method: "GET",
        url: `/users${serialize(
            {
                ...mapPagination(pagination),
                ...mapOrder(order),
                ...mapFilters(filters),
            },
            true,
        )}`,
    };
};

export const useUserListQuery = createApiQueryHook<IUserListQueryParameters, IUserListQueryResult>(userListQuery);
